module.exports = __webpack_public_path__ + "static/img/6.d7383ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/6.jpg
// module id = 7/+o
// module chunks = 1